import React from 'react';
import { DragSource } from 'react-dnd';

const source = {
  beginDrag(props, monitor, component) {
    return { type: props.type, props: {values:props.defaultProps.values, content:props.defaultProps.content}, children: [] , style: {}, childOf:'Body'};
  }
};

const RowItem = ({ type, component, connectDragSource, defaultProps }) => connectDragSource(
  <div style={{backgroundColor: '#fff', color: '#eee'}}>
    <div style={{backgroundColor: 'transparent', color: '#eee', padding: 10}}>
      {React.createElement(
        defaultProps.layout, defaultProps
      )}
    </div>
  </div>
);

export default DragSource('Body', source, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
}))(RowItem);



// WEBPACK FOOTER //
// ./src/editor/layout/catalog/RowItem.js